module.exports = __webpack_public_path__ + "static/cereal-small-ed8749013ce84bc4328a6d01ff443308.png";